module.exports = __webpack_public_path__ + "static/media/logo-ai2-fullColor.c6d5fd69.svg";